import { render, staticRenderFns } from "./PEARoleDropDown.vue?vue&type=template&id=9c9ded3c&scoped=true"
import script from "./PEARoleDropDown.vue?vue&type=script&lang=js"
export * from "./PEARoleDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9ded3c",
  null
  
)

export default component.exports